function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { Container, TableElement, ShadowContainer, ShadowWrapped } from './elements';
import TableBody from './TableBody';
import TableHeader from './TableHeader';
import TableFooter from './TableFooter';
/**
 * A Table displays structured data through rows and columns.
 * It can sort by column (asc, desc).
 *
 */

var Table = /*#__PURE__*/function (_PureComponent) {
  _inherits(Table, _PureComponent);

  var _super = _createSuper(Table);

  function Table() {
    var _this;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      firstCellWidth: 0,
      shadowSide: null,
      // Stores which column should be sorted.
      sort: null,
      unfoldedRows: []
    });

    _defineProperty(_assertThisInitialized(_this), "rowHeaderRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "containerRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "bodyRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      _this.setFirstCellWidth();

      _this.setContainerShadow();
    });

    _defineProperty(_assertThisInitialized(_this), "onScroll", function () {
      _this.setContainerShadow();
    });

    _defineProperty(_assertThisInitialized(_this), "setFirstCellWidth", function () {
      var firstCellWidth = _this.rowHeaderRef && _this.rowHeaderRef.current && _this.rowHeaderRef.current.offsetWidth;

      _this.setState({
        firstCellWidth: firstCellWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setContainerShadow", function () {
      var containerRefRect = _this.containerRef.current.getBoundingClientRect();

      var bodyRefRect = _this.bodyRef.current.getBoundingClientRect();

      var shadowSide = 'both';

      if (containerRefRect.left === bodyRefRect.left && containerRefRect.right === bodyRefRect.right) {
        shadowSide = null;
      } else if (containerRefRect.left === bodyRefRect.left) {
        shadowSide = 'left';
      } else if (containerRefRect.right === bodyRefRect.right) {
        shadowSide = 'right';
      }

      _this.setState({
        shadowSide: shadowSide
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSortChange", function (sort) {
      var onSortChange = _this.props.onSortChange;

      if (onSortChange) {
        onSortChange(sort);
      } else {
        _this.setState({
          sort: sort
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowClick", function (item, key) {
      var unfoldedRows = _this.state.unfoldedRows;
      var onClick = _this.props.rowsDef.onClick;

      if (item.children) {
        // row needs to be folded back
        if (unfoldedRows.includes(key)) {
          var unfoldedRowsNewState = unfoldedRows.filter(function (keyItem) {
            return !keyItem.startsWith(key);
          });

          _this.setState({
            unfoldedRows: unfoldedRowsNewState
          });
        } else {
          _this.setState({
            unfoldedRows: [].concat(_toConsumableArray(unfoldedRows), [key])
          });
        }
      } else if (onClick) {
        // row is a "leaf", i.e. at the latest level in the data
        onClick(item, key);
      }
    });

    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isScrollable = this.props.isScrollable;

      if (isScrollable) {
        this.setFirstCellWidth();
        addEventListener('resize', this.onResize);
        this.containerRef.current.addEventListener('scroll', this.onScroll);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeEventListener('resize', this.onResize);
      this.containerRef.current.removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: "render",
    value:
    /**
     * Renders the component.
     *
     * @return {jsx}
     */
    function render() {
      var _this$props = this.props,
          colsDef = _this$props.colsDef,
          data = _this$props.data,
          dataTotal = _this$props.dataTotal,
          height = _this$props.height,
          isHoverable = _this$props.isHoverable,
          isScrollable = _this$props.isScrollable,
          onClick = _this$props.rowsDef.onClick,
          sortProps = _this$props.sort,
          striped = _this$props.striped,
          width = _this$props.width;
      var _this$state = this.state,
          firstCellWidth = _this$state.firstCellWidth,
          shadowSide = _this$state.shadowSide,
          sortState = _this$state.sort,
          unfoldedRows = _this$state.unfoldedRows;
      var sort = sortProps || sortState;
      var tableHeaderProps = {
        colsDef: colsDef,
        isScrollable: isScrollable,
        onSortChange: this.handleSortChange,
        rowHeaderRef: this.rowHeaderRef,
        sort: sort
      };
      var tableBodyProps = {
        bodyRef: this.bodyRef,
        colsDef: colsDef,
        data: data,
        handleRowClick: this.handleRowClick,
        hasClickCallback: !!onClick,
        isHoverable: isHoverable,
        isScrollable: isScrollable,
        sort: sort,
        striped: striped,
        unfoldedRows: unfoldedRows
      };
      var tableFooterProps = {
        colsDef: colsDef,
        dataTotal: dataTotal,
        isScrollable: isScrollable,
        isHoverable: isHoverable
      };
      return /*#__PURE__*/React.createElement(ShadowWrapped, {
        containerHeight: height
      }, /*#__PURE__*/React.createElement(ShadowContainer, {
        side: shadowSide,
        firstCellWidth: firstCellWidth
      }), /*#__PURE__*/React.createElement(Container, {
        ref: this.containerRef,
        "data-testid": "table-container",
        containerHeight: height,
        isScrollable: isScrollable
      }, /*#__PURE__*/React.createElement(TableElement, {
        width: isScrollable ? 'initial' : width,
        colsDef: colsDef
      }, /*#__PURE__*/React.createElement(TableHeader, tableHeaderProps), /*#__PURE__*/React.createElement(TableBody, tableBodyProps), /*#__PURE__*/React.createElement(TableFooter, tableFooterProps))));
    }
  }]);

  return Table;
}(PureComponent);

var array = PropTypes.array,
    arrayOf = PropTypes.arrayOf,
    bool = PropTypes.bool,
    func = PropTypes.func,
    node = PropTypes.node,
    number = PropTypes.number,
    object = PropTypes.object,
    oneOf = PropTypes.oneOf,
    oneOfType = PropTypes.oneOfType,
    shape = PropTypes.shape,
    string = PropTypes.string;
/** Prop types. */

Table.propTypes = {
  /** Columns definition */
  colsDef: arrayOf(shape({
    align: oneOf(['left', 'center', 'right']),
    defaultSortOrder: oneOf(['asc', 'desc']),
    isRowHeader: bool,
    sortBy: func,
    format: func,
    isSortable: bool,
    name: string.isRequired,
    title: node.isRequired,
    total: func,
    value: func.isRequired,
    width: oneOfType([string, number])
  })).isRequired,

  /** Data to display */
  data: array.isRequired,

  /**
   * This props going to add a fixed row at the bottom of the table.
   * Usually this props is used to display the total of each column.
   * */
  dataTotal: object,

  /** Height of the table use this props only is the table is scrollable */
  height: string,

  /**
   * Define if the table is scrollable or not.
   * When the table is scrollable the column header stick to the top and the row header stick to the left.
   * The table body going to scroll in both axies x and y depending of the content overflow.
   **/
  isScrollable: bool,

  /**
   * Define if the table is isHoverable or not.
   * On hover of a row, its background color changes, increasing contrast with others and improving readability.
   **/
  isHoverable: bool,

  /**
   * Enable controller sort of table
   */
  onSortChange: func,

  /** Rows definition */
  rowsDef: shape({
    onClick: func
  }),
  sort: shape({
    column: string,
    order: oneOf(['asc', 'desc'])
  }),

  /** Whether rows should alternate color or not */
  striped: bool,

  /** Width of the table use this props only is the table is not scrollable*/
  width: string
};
/** Default props. */

Table.defaultProps = {
  dataTotal: null,
  height: 'initial',
  isScrollable: false,
  isHoverable: false,
  onSortChange: null,
  rowsDef: {
    onClick: null
  },
  sort: null,
  striped: false,
  width: '100%'
};
export default Table;